import React from "react"
import copy from 'copy-to-clipboard';

import { Container } from "./styles";

import "font-awesome/css/font-awesome.min.css"
import {handleRecords} from "./records";
import NextWeek from "./NextWeek"
import LastWeek from "./RecentEvents"
import CopyBtn from "./CopyBtn"


const API_KEY = "keyM3HJcUYjFlriFE"

let response = [],
  clipboardText = ""

export default class Main extends React.Component {
  state = {
    records: [],
    nextWeekEvents: [],
    recentEvents: [],
    isLoaded: false,
    copied: false,
  }
  loadData = (offset = "") => {
    fetch(`https://api.airtable.com/v0/appmDngHl6n1PvFv7/Table%201?api_key=${ API_KEY }&offset=${ offset }`)
      .then(res => res.json())
      .then(json => {
        response = [...response, ...json.records]
        if(json.offset) {
          this.loadData(json.offset)
        }
        else  {
          const { nextWeek, recentEvents } = handleRecords(response)
          this.setState({
            nextWeekEvents: nextWeek,
            recentEvents,
            isLoaded: true
          })
        }
      })
      .catch(e => {
        console.log(e.message)
      })
  }
  handleCopy = () => {
    copy(clipboardText)
    // this.setState({copied: true})
    // setTimeout(() => {
    //   this.setState({copied: false})
    // }, 750)
  }
  handleClipboard = (text) => {
    clipboardText += text
  }
  componentWillMount() {
    this.loadData()
  }
  render() {
    const { isLoaded, nextWeekEvents, recentEvents, copied } = this.state
    return (
      <Container>
        <div className="events-container">
          <CopyBtn onClick={this.handleCopy} />
          {
            !isLoaded &&
            <div className="loader">
              <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"/>
            </div>
          }
          <div className="content">
            <NextWeek events={nextWeekEvents} handleClipboard={this.handleClipboard} />
            <LastWeek events={recentEvents} handleClipboard={this.handleClipboard} />
          </div>
        </div>
      </Container>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/Main/index.js